import {toast} from "react-toastify";
import ToastMessage from "../components/common/toast-message";
import React from "react";

export const getMinimumOrderQuantityAndNotify = (qty, minimum_order_quantity) => {
  if (qty < minimum_order_quantity){
    let additional = minimum_order_quantity - qty
    let message = "This product has a minimum order quantity of " + minimum_order_quantity + " outers, therefore we have added " + additional + " additional product to your basket to meet this minimum order quantity.";
    toast.error(<ToastMessage iconStyle="error" message={message}/>);
    qty = minimum_order_quantity
  }
  return qty
}



// WEBPACK FOOTER //
// ./src/utils/minimum-order-quantity-toast.js